import React, { Component, Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class ResponsiveMenu extends Component {

  state = {
    sortShow: window.sortShow || false,
    sortBy: this.props.sortField || "_score"

  }

  _toggleSort = e => {
    window.sortShow = !this.state.sortShow
    this.setState({
      ...this.state,
      sortShow: !this.state.sortShow
    })
  }

  _setSortBy = sort => e => {
    this.props.changeSort(sort, "desc")
  }

  render() {
    return(
      <div className="responsive-menu-wrapper">
        <div className="responsive-menu-buttons">
          <div className="responsive-menu-button active" onClick={this.props.showResponsiveMenu(false)}>
            DONE
          </div>
          <div className="responsive-menu-button" onClick={this.props.resetFilters}>
            Reset
          </div>
        </div>
        <div className="responsive-menu-item accordion" onClick={this._toggleSort}>
          Sort by
          {
            this.state.sortShow
            ?
            <FontAwesomeIcon icon='minus' />
            :
            <FontAwesomeIcon icon='plus' />
          }
        </div>
        {
          this.state.sortShow
          &&
          <Fragment>
            <div className="responsive-menu-item" onClick={this._setSortBy("_score")}>
              Relevance
              <input type="checkbox" defaultChecked={this.state.sortBy === "_score"} />
            </div>
            <div className="responsive-menu-item" onClick={this._setSortBy("published_at")}>
              Date
              <input type="checkbox" defaultChecked={this.state.sortBy === "published_at"} />
            </div>
          </Fragment>
        }
        <Fragment>
          {
            this.props.staticFacetsMap.map(sf => (
              <StaticFacet
                key={sf.field}
                f={sf}
                isFacetActive={this.props.isFacetActive}
                addFacet={this.props.addFacet}
                delFacet={this.props.delFacet}
              />
            ))
          }
        </Fragment>
        <Fragment>
          {
            this.props.facetsNameMap.map(f => (
              <Facet
                key={f.field}
                isFacetActive={this.props.isFacetActive}
                f={f}
                facets={this.props.facets}
                addFacet={this.props.addFacet}
                delFacet={this.props.delFacet}
              />
            ))
          }
        </Fragment>
      </div>
    )
  }

}

class StaticFacet extends Component {
  state = {
    show: window.facetsOpened && window.facetsOpened.includes(this.props.f.field),
    showAll: false
  }

  _toggleShow = field => e => {
    if(window.facetsOpened && Array.isArray(window.facetsOpened)) {
      if(window.facetsOpened.includes(field)) {
        window.facetsOpened = window.facetsOpened.filter(f => f !== field)
      }
      else {
        window.facetsOpened = [ field, ...window.facetsOpened ]
      }
    }
    else {
      window.facetsOpened = [ field ]
    }
    this.setState({
      ...this.state,
      show: !this.state.show
    })
  }

  _toggleFacet = (isSelected, cat, value) => e => {
    if(isSelected) {
      this.props.delFacet(cat, value)()
    }
    else {
      this.props.addFacet(cat, value)()
    }
  }

  render() {
    const { f } = this.props
    return (
      <Fragment key={f.displayName}>
        <div className="responsive-menu-item accordion" onClick={this._toggleShow(f.field)}>
          {f.displayName}
          {
            this.state.show
            ?
            <FontAwesomeIcon icon='minus' />
            :
            <FontAwesomeIcon icon='plus' />
          }
        </div>
        {
          this.state.show && f.values.map(fv => {
            const isSelected = this.props.isFacetActive(f.field, fv)
            return(
              <div key={fv} className="responsive-menu-item" onClick={this._toggleFacet(isSelected, f.field, fv)}>
                {fv}
                <input type="checkbox" defaultChecked={isSelected} />
              </div>
            )
          })
        }
      </Fragment>
    )
  }

}


class Facet extends Component {
  state = {
    show: window.facetsOpened && window.facetsOpened.includes(this.props.f.field),
    showAll: false
  }

  getFacets = facets => {

    const fks = Object.keys(facets || {})

    return  (fks.length > 5 && !this.state.showAll)
            ?
            fks.slice(0, 5)
            :
            fks
  }

  _toggleShow = field => e => {
    if(window.facetsOpened && Array.isArray(window.facetsOpened)) {
      if(window.facetsOpened.includes(field)) {
        window.facetsOpened = window.facetsOpened.filter(f => f !== field)
      }
      else {
        window.facetsOpened = [ field, ...window.facetsOpened ]
      }
    }
    else {
      window.facetsOpened = [ field ]
    }
    this.setState({
      ...this.state,
      show: !this.state.show
    })
  }

  _toggleFacet = (isSelected, cat, value) => e => {
    if(isSelected) {
      this.props.delFacet(cat, value)()
    }
    else {
      this.props.addFacet(cat, value)()
    }
  }

  render() {
    const { f, facets } = this.props
    return(
      <Fragment key={f.displayName}>
        <div className="responsive-menu-item accordion" onClick={this._toggleShow(f.field)}>
          {f.displayName}
          {
            this.state.show
            ?
            <FontAwesomeIcon icon='minus' />
            :
            <FontAwesomeIcon icon='plus' />
          }
        </div>
        {
          this.state.show && this.getFacets(facets[f.field]).map(fv => {
            const isSelected = this.props.isFacetActive(f.field, fv)
            return(
              <div key={fv} className="responsive-menu-item" onClick={this._toggleFacet(isSelected, f.field, fv)}>
                {fv} ({facets[f.field][fv]})
                <input type="checkbox" defaultChecked={isSelected}/>
              </div>
            )
          })
        }
      </Fragment>
    )
  }
}

export default ResponsiveMenu